import { Colors } from "models/Colors";

export const GoalCategories = [
	{ name: "Gadgets", color: Colors.primary },
	{ name: "Travel", color: Colors.purple },
	{ name: "Automobile", color: Colors.lightBlue },
	{ name: "Lifestyle", color: Colors.green },
	{ name: "Events", color: Colors.orange },
]